export type { ModalContentProps } from "./ModalContent";
export { ModalContent } from "./ModalContent";
